export default function bmiCalculation(weight_Kg: number, height_cm: number) {
    return Math.round(10 * weight_Kg / (height_cm * height_cm / 10000)) / 10
}